<template>
  <p v-bg-typography="'body-m'" class="video-upload-warning">
    <bg-field
      label="Please upload the video below"
      class="bg-field--zero-margin"
    >
      When you have uploaded the video, we can start the process
    </bg-field>
  </p>
</template>

<style lang="scss" scoped>
.video-upload-warning {
  background-color: #00deab;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 15px;
}

.bg-field--zero-margin {
  margin: 0px;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgField from "@/components/bg-field";

export default {
  components: {
    BgField,
  },
  directives: {
    BgTypography,
  },
};
</script>
